// extracted by mini-css-extract-plugin
module.exports = {"base":"FHIRRecordDetails_base__1Gs-E","tabs":"FHIRRecordDetails_tabs__1GNMf","noDetails":"FHIRRecordDetails_noDetails__30Z1r","closeButton":"FHIRRecordDetails_closeButton__L3aJ3"};